<template>
  <div v-if="LoggedIn === true" class="toolbar bottomToolbarContainer" :style="cssVars">
    <bottom-items :serviceId="serviceId" :bottomItemsData="bottomItemsData"></bottom-items>
  </div>
</template>

<script>
import itemsBottombar from '@/components/bottomToolbar/itemsBottombar.vue'
import bottomItemsData from '@/components/bottomToolbar/data/bottomItemsData.json'
import _ from 'lodash'
import conf from "@/config/config.dev";
import designToolBox from '@/design/designToolBox.json'
import designDealprudence from '@/design/designDealprudence.json'

const flagTOOLBOX = conf.visual === 'TOOLBOX'

const design = flagTOOLBOX ? designToolBox : designDealprudence

/** TLV 10/03/2020
* @brief Component qui gère l'emplacement et la présence du footer de DealPrudence,
*         et qui envoie l'id du service actuel ainsi que les données au component bottom-items (au format .json)
*         pour que ce dernier les affiche correctement.
*         Lorsque les données du footer sont modifiées ici, le component bottom-items
*         est automatiquement mis à jour avec les nouvelles données
*/
export default {
  name: 'bottomToolbar',
  components: {
    'bottom-items': itemsBottombar
  },
  data () {
    return {
      serviceId: this.$engine.user.currentService.id,
      LoggedIn: false,
      colorBackground: '',
      bottomItemsData: [],
      design: design.menu
    }
  },
  created: function () {
    let that = this
    this.$bus.on('service:change', (val) => {
      this.serviceId = this.$engine.user.currentService.id
    })
    // Le footer n'est affiché que pour les utilisateurs connectés
    this.$bus.$on('login', (val) => {
      that.LoggedIn = val
    })
    this.$bus.$on('logout', () => {
      that.LoggedIn = ''
    })
    this.bottomItemsData = _.cloneDeep(bottomItemsData.bottomMenu)
    this.bottomItemsData.forEach(item => { item.isSelected = false })
    /** TLV 10/03/2020 - Gestion de l'affichage des pastilles sur la barre de footer (version mobile).
        Globalement le même concept que sur le panneau de gauche de la version Web,
          voir les commentaires de common/leftPanel/servicesMenu.vue pour les détails */
    this.$bus.on('nextLink', link => {
      this.bottomItemsData = _.cloneDeep(this.bottomItemsData)
      let selectNewItemOnPanel = false
      this.bottomItemsData.forEach(item => {
        if (link && link.includes(this.checkSelectedLink(item.link))) {
          selectNewItemOnPanel = true
          item.isSelected = true
        }
      })
      // On passe tous les autres items à false pour éviter d'avoir deux sélections en même temps
      if (selectNewItemOnPanel) {
        this.bottomItemsData.forEach(item => {
          if (link && !link.includes(this.checkSelectedLink(item.link))) {
            item.isSelected = false
          }
        })
      }
    })
  },
  computed: {
    cssVars () {
      return {
        '--headbandColor': this.design.headbandColor,
        '--headbandTextColor': this.design.headbandTextColor,
        '--headbandColorHover': this.design.headbandColorHover,
        '--headbandColorHover2': this.design.headbandColorHover2,
        '--headbandTextColorHover': this.design.headbandTextColorHover,
        '--headbandTextColorHover2': this.design.headbandTextColorHover2
      }
    }
  },
  methods: {
    checkSelectedLink (link) {
      if (typeof link !== 'string') {
        return link[this.$engine.user.currentService.id]
      }
      return link
    }
  }
}
</script>

<style>
.bottomToolbarContainer {
  background-color: var(--headbandColor);
  color: var(--headbandTextColor);
  width:105%;
}
.bottomToolbarInner {
  width: 290%;
  padding: 0px;
  display: block;
  border-top: 1px solid #e5e5e5;
}
</style>
